import {
    getFurnishingStatus,
    deleteFurnishingStatus,
    createFurnishingStatus,
    updateFurnishingStatus
} from '../../../services/FurnishingStatusService';
import {
    CONFIRMED_GET_FURNISHING_STATUS
} from './FurnishingStatusTypes';

export function getFurnishingStatusAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
            dispatch({ type: 'FURNISHING_STATUS_LOADING' });
            getFurnishingStatus(currentPage, pageSize, searchTerm, filterQuery)
                .then((response) => {
                    dispatch(confirmedGetFurnishingStatusAction(response.data.data));
                })
                .catch(() => {
                    dispatch(confirmedGetFurnishingStatusAction({ rows: [], count: 0, pages: 1 }));
                });
    };
}

export function confirmedGetFurnishingStatusAction(data) {
    return {
        type: CONFIRMED_GET_FURNISHING_STATUS,
        payload: data,
    };
}

export function deleteFurnishingStatusAction(id, history) {
    return (dispatch, getState) => {
        return deleteFurnishingStatus(id).then((response) => {
            return response;
        });
    };
}

export function createFurnishingStatusAction(data) {
    return () => {
        return createFurnishingStatus(data).then((response) => {
            return response;
        });
    };
}

export function updateFurnishingStatusAction(id, data) {
    return () => {
        return updateFurnishingStatus(id, data).then((response) => {
            return response;
        });
    };
}

